import { render } from "./PackagesManager.vue?vue&type=template&id=13639778&scoped=true"
import script from "./PackagesManager.vue?vue&type=script&lang=js"
export * from "./PackagesManager.vue?vue&type=script&lang=js"

import "./PackagesManager.vue?vue&type=style&index=0&id=13639778&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13639778"]])

export default __exports__